import React, { Component } from 'react';

class Hanging extends Component {
	render() {
        const {selectedHanging} = this.props;
        return (
            <tr>
                <th>Hanging</th>
                <td>{selectedHanging.size > 0 ? selectedHanging.getIn(['title', 'rendered']) : '-'}</td>
                <td>-</td>
            </tr>
        );
	}
}

export default Hanging;